import CommonUAReelStructure from "../Constants/ReelsDataStructure.js"; // Import the structure

export const fetchFeedDataForReels = async () => {
  try {
    const response = await fetch("/api/mock/Reels/ReelsMockfeeddata.json"); // Fetch from public folder
    const data = await response.json();

    // Ensure data follows CommonUAReelStructure
    const formattedData = {
      accUserId: data.accUserId || "",
      accProfileImage: data.accProfileImage || "", 
      reellist: (data.reellist || []).map((reel) => ({
        reelid: reel.reelid || null,
        userId: reel.userId || "",
        videoUrl: reel.videoUrl || "",
        description: reel.description || "",
        thumbnail: reel.thumbnail || "",
        date: reel.date || "",
        location: reel.location || "",
        likesCount: reel.likesCount || 0,
        commentsCount: reel.commentsCount || 0,
        impressions: reel.impressions || 0,
        comments: (reel.comments || []).map((comment) => ({
          userId: comment.userId || "",
          text: comment.text || "",
          date: comment.date || "",
        })),
      })),
    };

    return formattedData;
  } catch (error) {
    console.error("Error fetching reels feed data:", error);
    return { accUserId: "", profileList: [] };
  }
};

export default fetchFeedDataForReels;
